import { render, staticRenderFns } from "./addContactModal.vue?vue&type=template&id=6351a0cb&"
import script from "./addContactModal.vue?vue&type=script&lang=js&"
export * from "./addContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports